import { useEffect } from "react";
import NavBar from "@/components/site/NavBar";
import Hero from "@/components/site/Hero";
import AttorneyBar from "@/components/site/AttorneyBar";
import FearSection from "@/components/site/FearSection";
import FounderStory from "@/components/site/FounderStory";
import GoogleReviews from "@/components/site/GoogleReviews";
import Testimonials from "@/components/site/Testimonials";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";

const heroImage =
  "https://images.unsplash.com/photo-1521295121783-8a321d551ad2?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=80&w=1200";

const headline = (
  <>
    Built something{" "}
    <span className="italic font-medium text-ink">worth protecting?</span>{" "}
    <br className="hidden md:block" />
    <span className="italic font-medium text-teal">We get it.</span>
  </>
);

const subhead = (
  <>
    <span className="text-ink font-medium">Binoye Jos, Esq.</span> built{" "}
    <span className="text-ink font-medium">four successful companies</span>{" "}
    before becoming a family law attorney. Are you afraid of losing your
    assets? Mr. Jos knew how to protect his — and he knows what it costs to
    lose them. Don&rsquo;t live in fear. Contact JOS Family Law and let our
    firm protect your assets. JOS Family Law handles complex and high-asset
    divorce in Orange County for{" "}
    <span className="text-ink font-medium">
      business owners, executives, and investors
    </span>{" "}
    with something real at stake.
  </>
);

const pullquote = (
  <>
    Years building. Years scaling. Years protecting.{" "}
    <span className="italic text-teal">
      You are not alone. We will protect your assets.
    </span>
  </>
);

const statBar = [
  { num: "4", label: "Companies Built" },
  { num: "$400K+", label: "In Fees Navigated" },
  { num: "2", label: "Law Firms Fired" },
];

const fears = [
  "How much of the business do I actually keep?",
  "Who pays for the forensic accountant?",
  "What happens to my real estate and investments?",
  "Can I trust my attorney to understand what I've built?",
];

const founderHeading = (
  <>
    Binoye Jos, Esq. built four companies before becoming a family law
    attorney.{" "}
    <span className="italic">He knows what your assets are worth.</span>
  </>
);

const founderParagraphs = [
  "Binoye Jos didn't just study complex divorce — he lived it. He hired two prominent law firms, spent $400,000, and was told he'd never get equal custody of his son. He represented himself, won equal custody, then went to law school. Before that, he built four companies. He understands both sides of the equation: the legal system and the real-world value of what you've created.",
  "When the firm steps into your case, it does so with the operator's eye for what matters — and the attorney's discipline for protecting it.",
];

const testimonials = [
  {
    name: "Ms. Valdez",
    quote:
      "This firm is not in the business of telling you what you want to hear. It is focused on winning your case. The level of legal experience and strategic thinking is the kind most attorneys cannot match.",
  },
  {
    name: "Ms. Lee",
    quote:
      "Jos Family Law will fight for your case and what is fair. I came to them with a complex financial situation and they handled every piece of it with clarity and strategy.",
  },
  {
    name: "Mr. Kogami",
    quote:
      "If it wasn't for Jos Family Law, I would not have been able to come to a settlement I felt was fair. They knew exactly how to handle the financial complexity of my case.",
  },
];

export default function HighAsset() {
  useEffect(() => {
    document.title =
      "Jos Family Law — High Asset Divorce Attorney, Orange County CA";
    const meta =
      document.querySelector('meta[name="description"]') ||
      (() => {
        const m = document.createElement("meta");
        m.name = "description";
        document.head.appendChild(m);
        return m;
      })();
    meta.setAttribute(
      "content",
      "Complex and high-asset divorce in Orange County. Our founder built four companies before becoming a family law attorney. He knows what your assets are worth. Call (714) 733-7066."
    );
  }, []);

  return (
    <main data-testid="highasset-page" className="relative bg-paper text-ink">
      <NavBar />
      <Hero
        source="High Asset"
        eyebrow="Family Law Attorney · Orange County, California"
        headline={headline}
        subhead={subhead}
        primaryCtaLabel="Schedule a Confidential Consultation"
        ctaSubNote="Confidential · No Obligation"
        statBar={statBar}
        heroImage={heroImage}
        imageCaption="The attorney you choose can make a meaningful difference in protecting what you've built."
        pullquoteLabel="Our Difference"
        pullquote={pullquote}
        formCtaLabel="Schedule Your Confidential Consultation"
      />
      <AttorneyBar />
      <FearSection
        eyebrow="What's At Stake"
        heading={
          <>
            The questions{" "}
            <span className="italic font-medium">
              that keep you up at night.
            </span>
          </>
        }
        fears={fears}
      />
      <FounderStory heading={founderHeading} paragraphs={founderParagraphs} />
      <GoogleReviews />
      <Testimonials
        items={testimonials}
        heading={
          <>
            Satisfied <span className="italic">clients.</span>
          </>
        }
        clientLabel="High Asset Divorce Client"
      />
      <FinalCTA source="High Asset" />
      <Footer />
    </main>
  );
}
